import { AbstractAuditDto, AuditViewDto, MinorDataDto, MsisdnDto, ResultListDto, RolePermissionEnum, SearchResultDocumentDto } from './../../service/dto';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Observable, Subscription } from 'rxjs';
import { AbstractDto, SearchResultMsisdnDto } from '../../service/dto';
import { HttpSubscriberService } from '../../service/http-subscriber.service';
import { Location } from '@angular/common';
import { faCheck, faExpand, faHourglass, faNotdef, faXmark } from '@fortawesome/free-solid-svg-icons';
import { HttpAuditService } from '../../service/http-audit.service';

@Component({
	selector: 'app-subscriber-document-view',
	templateUrl: './subscriber-document-view.component.html',
	styleUrl: './subscriber-document-view.component.scss',
	standalone: false
})
export class SubscriberDocumentViewComponent implements OnInit, OnDestroy {
	private subscription = new Subscription();
	data?: SearchResultDocumentDto;
	faExpand = faExpand;
	selectedTabIndex = 0;
	faCheck = faCheck;
	faXmark = faXmark;
	faNotdef = faNotdef;
	faHourglass = faHourglass;


	constructor(private service: HttpSubscriberService, private auditService: HttpAuditService, private activatedRoute: ActivatedRoute, private location: Location) {

	}

	ngOnInit(): void {
		this.subscription = this.activatedRoute.params.subscribe(params => {
			const documentId = +params['documentId'];
			this.service.getDocument(documentId).subscribe({
				next: data => this.data = data,
				error: err => console.error('Failed to load document', err)
			});
		});
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	getGivenNames(): string {
		if (!this.data) {
			return '';
		}
		let out = '';
		let seperator = '';
		if (this.data.document.firstName) {
			out += seperator + this.data.document.firstName;
			seperator = ' ';
		}
		if (this.data.document.secondName) {
			out += seperator + this.data.document.secondName;
			seperator = ' ';
		}
		if (this.data.document.otherNames) {
			out += seperator + this.data.document.otherNames;
			seperator = ' ';
		}
		return out;
	}
	getMinorGivenNames(minor: MinorDataDto): string | undefined {
		if (!minor) {
			return undefined;
		}
		let out = '';
		let seperator = '';
		if (minor.firstName) {
			out += seperator + minor.firstName;
			seperator = ' ';
		}
		if (minor.secondName) {
			out += seperator + minor.secondName;
			seperator = ' ';
		}
		if (minor.otherNames) {
			out += seperator + minor.otherNames;
			seperator = ' ';
		}
		return out;
	}
	findMinorIndexPlus1(msisdn: MsisdnDto): number | undefined {
		if (!msisdn.minorDataId) {
			return undefined;
		}
		for (let i = 0; i < this.data!.minors.length; i++) {
			if (this.data?.minors[i].id == msisdn.minorDataId) {
				return i + 1;
			}
		}
		return undefined;
	}

	findMinor(msisdn: MsisdnDto): MinorDataDto | undefined {
		if (!msisdn.minorDataId) {
			return undefined;
		}
		for (let i = 0; i < this.data!.minors.length; i++) {
			if (this.data?.minors[i].id == msisdn.minorDataId) {
				return this.data?.minors[i];
			}
		}
		return undefined;
	}
	trackByHashCode(index: number, item: AbstractDto): any {
		return item.hashCode;
	}

	goBack() {
		this.location.back();
	}

	fetchAudits = (page: number, pageSize: number): Observable<ResultListDto<AuditViewDto>> => {
		return this.auditService.getViewHistoryOfDocument(this.data!.document.id, page, pageSize);
	}

}
